const $ = require('jquery');
'use strict';
///*------------------------------------------
///* полноэкранное меню навигации по секциям    
///*------------------------------------------
const menuOverlay = (() => {   
  var pluginName = 'fatNav',
    defaults = {};   
  function Plugin(options) {
    this.settings = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }
    
  $.extend(Plugin.prototype, {
        
    init: function() {

      var self = this;
      var $nav = this.$nav = $('.fat-nav');
      var $hamburger = $('.hamburg-menu');          
      this._bodyOverflow = $('body').css('overflow');
      // Hack to prevent mobile safari scrolling the whole body when nav is open
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {              
        $nav.children().css({
          'height': '110%',
          'transform': 'translateY(-5%)',
        });            
      }
    
      $().add($hamburger).add($nav.find('a')).on('click', function() {
        self.toggleNav();
      });        
    },
        
    toggleNav: function() {
            
      var self = this;

      this.$nav.fadeToggle(200);
      
      self.toggleBodyOverflow();
    
      $().add(this.$nav).toggleClass('active');
    },
    toggleBodyOverflow: function() {
            
      var self = this;
      
      var $body = $('body');
            
      $body.toggleClass('no-scroll');
      
      var isNavOpen = $body.hasClass('no-scroll');
      
      $body.width($body.width());
      $body.css('overflow', isNavOpen ? 'hidden' : self._bodyOverflow);
      
    },     
  });
    
  if (typeof $[pluginName] === 'undefined') {
        
    $[pluginName] = function(options) {
      return new Plugin(this, options);
    };        
  }
})($, window, document);
export default menuOverlay;


// WEBPACK FOOTER //
// ./app/components/hamburger_menu.js